<div *ngIf="isLoading | async" class="box loading d-flex justify-content-center align-items-center">
    <!-- <img class="loading--imagem" src="./../../../assets/image/logos/logo-animado.svg"> -->
    <div class="overlay">
        <i class="fa fa-refresh fa-spin"></i>
    </div>
</div>